import { useMemo } from "react";

interface Props {
  children?: React.ReactNode;
  className?: string;
  size?: "sm" | "md" | "lg";
}

export const Label = (props: Props) => {
  const className = useMemo(() => {
    let name = "label";
    if (props.size === "sm") name += " label-sm";
    else if (props.size === "lg") name += " label-lg";
    if (props.className) name += " " + props.className;
    return name;
  }, [props.size, props.className]);
  return <span className={className}>{props.children}</span>;
};
